export default "__VITE_ASSET__uPrOz_y___"